// Test utility for geocoding service
// You can import and call these functions in the browser console to test

import { searchLocations, reverseGeocode, geocodingService } from './geocodingService';

// Test search functionality
export const testSearch = async (query = 'New York') => {
    console.log(`Testing search for: "${query}"`);

    try {
        const results = await searchLocations(query);
        console.log('Results:', results);
        return results;
    } catch (error) {
        console.error('Search test failed:', error);
        return null;
    }
};

// Test reverse geocoding
export const testReverse = async (lat = 40.7128, lng = -74.0060) => {
    console.log(`Testing reverse geocoding for: ${lat}, ${lng}`);

    try {
        const result = await reverseGeocode(lat, lng);
        console.log('Result:', result);
        return result;
    } catch (error) {
        console.error('Reverse geocoding test failed:', error);
        return null;
    }
};

// Test cache functionality
export const testCache = async () => {
    console.log('Testing cache functionality...');

    // Clear cache first
    geocodingService.clearCache();
    console.log('Cache cleared');

    // First search (should hit API)
    console.log('First search - should hit API:');
    const start1 = Date.now();
    const result1 = await searchLocations('London');
    const time1 = Date.now() - start1;
    console.log(`First search took ${time1}ms:`, result1);

    // Second search (should hit cache)
    console.log('Second search - should hit cache:');
    const start2 = Date.now();
    const result2 = await searchLocations('London');
    const time2 = Date.now() - start2;
    console.log(`Second search took ${time2}ms:`, result2);

    console.log(`Cache speedup: ${time1 - time2}ms faster`);

    return { first: time1, second: time2, speedup: time1 - time2 };
};

// Test rate limiting
export const testRateLimit = async () => {
    console.log('Testing rate limiting...');

    const queries = ['Paris', 'Berlin', 'Madrid'];
    const startTime = Date.now();

    for (const query of queries) {
        const searchStart = Date.now();
        await searchLocations(query);
        const searchTime = Date.now() - searchStart;
        console.log(`Search for "${query}" took ${searchTime}ms`);
    }

    const totalTime = Date.now() - startTime;
    console.log(`Total time for 3 searches: ${totalTime}ms`);
    console.log('Rate limiting is working if this took at least 2 seconds');

    return totalTime;
};

// Run all tests
export const runAllTests = async () => {
    console.log('=== Running Geocoding Service Tests ===');

    await testSearch('New York');
    console.log('---');

    await testSearch('London');
    console.log('---');

    await testReverse(51.5074, -0.1278); // London coordinates
    console.log('---');

    await testCache();
    console.log('---');

    await testRateLimit();

    console.log('=== Tests Complete ===');
};

// Make functions available globally for console testing
if (typeof window !== 'undefined') {
    window.testGeocoding = {
        testSearch,
        testReverse,
        testCache,
        testRateLimit,
        runAllTests
    };

    console.log('Geocoding tests available at window.testGeocoding');
    console.log('Try: testGeocoding.testSearch("Paris")');
} 